var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.label)?_c('span',{staticClass:"status-badge",attrs:{"data-tone":_vm.tone,"title":_vm.status.title}},[_c('span',{staticClass:"status-badge__dot",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.label)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }